module.exports = __webpack_public_path__ + "static/media/DO.48badacf.svg";